export default "/assets/yale-lock.a174cf546481c028ecd15e76ba625899.png";